var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollinear20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x80\x9A\xE7\x94\xA8\xE5\x9B\xBE\xE6\xA0\x87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630578",
    x: 13.8461,
    y: 4.61548,
    width: 6.52715,
    height: 2.17572,
    transform: "rotate(-45 13.8461 4.61548)",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630579",
    y: 18.4617,
    width: 6.52715,
    height: 2.17572,
    transform: "rotate(-45 0 18.4617)",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630580",
    x: 4.61548,
    y: 13.8462,
    width: 4.35143,
    height: 2.17572,
    transform: "rotate(-45 4.61548 13.8462)",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630581",
    x: 10.7693,
    y: 7.69226,
    width: 4.35143,
    height: 2.17572,
    transform: "rotate(-45 10.7693 7.69226)",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630582",
    x: 8.46161,
    y: 10,
    width: 2.17572,
    height: 2.17572,
    transform: "rotate(-45 8.46161 10)",
    fill: "#00C2FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollinear20);
export default __webpack_public_path__ + "static/media/collinear_20.55d460f862474ead389b8210404952a9.svg";
export { ForwardRef as ReactComponent };